<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('stock.list')">Stock</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> Nouveau
    </h1>
    <div class="bg-white rounded shadow overflow-hidden max-w-7xl">
      <form @submit.prevent="submit">
        <div class="px-8 pb-2 pt-8 flex flex-wrap">
          <text-input v-model="form.reference" :error="errors.reference" class="pr-6 pb-8 w-full lg:w-1/4" label="Reference" />
          <text-input v-model="form.bin" :error="errors.bin" class="pr-6 pb-8 w-full lg:w-1/4" label="BIN" />

          <div class="pr-6 pb-8 w-full lg:w-1/4">
            <label class="form-label">Marque:</label>
            <multiselect v-model="brand" deselect-label="supprimer" track-by="name" label="name" placeholder="Select one" :options="brands"
                         :error="errors.brand" :searchable="true" @input="asyncFind">
              <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.name }}</strong></template>
            </multiselect>
          </div>

          <div class="pr-6 pb-8 w-full lg:w-1/4">
            <label class="form-label">Model:</label>
            <multiselect  v-model="model" deselect-label="Can't remove this value" track-by="name" label="name" placeholder="Select one"
                          :options="modelsData" :searchable="true" :error="errors.model" :clear-on-select="false" :loading="isLoading"
                          open-direction="bottom" >
              <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.name }}</strong></template>
            </multiselect>
          </div>

        </div>

        <div class="px-8 py-2 flex flex-wrap">
          <text-input v-model="form.cost" :error="errors.cost" class="pr-6 pb-8 w-full lg:w-1/3" label="Cost" />

          <select-input v-model="form.category" :error="errors.category" class="pr-6 pb-8 w-full lg:w-1/3" label="Category">
            <option v-for="cat in categories" :key="cat.id" :value="cat.id">{{ cat.name }}</option>
          </select-input>

          <select-input v-model="form.type" :error="errors.type" class="pr-6 pb-8 w-full lg:w-1/3" label="Type">
            <option v-for="type in types" :key="type" :value="type" :selected="type === 'part'">{{type}}</option>
          </select-input>
        </div>

        <div class="px-8 py-2 pt-10 relative m-5 flex flex-wrap border-gray-200 border rounded-md">
          <h4 class="absolute top-2 left-2 font-bold text-lg">Quantité par shop</h4>
          <div class="flex flex-col w-5/12">
            <div v-for="shop in shops" class="flex flex-row pb-4">
              <label class="py-3 w-5/12">
                <input type="checkbox" class="form-checkbox" :value="shop.id" @change="toggle(shop.id)">
                <span class="ml-2 text-md font-bold text-gray-600">{{ shop.name }}</span>
                <span v-if="shop.type === 1" class="text-md text-gray-600">(general)</span>
              </label>
              <jet-input type="number" min="0" v-if="isActivated(shop.id)" class="w-24" v-model="form.shopsQuantity[shop.id]" :error="errors.shopsQuantity" placeholder=""/>
            </div>
          </div>
        </div>

        <div class="px-8 py-2 bg-gray-100 border-t border-gray-200 flex justify-end items-center">
          <loading-button :loading="sending" class="btn-indigo mx-2" type="submit">Sauvegarder</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Layouts/AppLayout'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'
import JetInput from '@/Jetstream/Input'
import mapValues from "lodash/mapValues";
import Multiselect from 'vue-multiselect'

import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  metaInfo: { title: 'Stock' },
  layout: Layout,
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    JetInput,
    Multiselect,
  },
  props: {
    errors: Object,
    filters: Object,
    brands: Array,
    models: Array,
    categories: Array,
    shops: Array,
    hasItOwnStock: Boolean
  },
  data() {
    return {
      modelsData: this.models,
      types: ['part', 'phone', 'accessory'],
      isLoading: false,
      sending: false,
      model: null,
      brand: null,
      form: {
        reference: null,
        bin: null,
        cost: null,
        type: null,
        category: null,
        shopsQuantity: null,
        activeShops: [],
      },
    }
  },
  watch: {},
  methods: {
    toggle(id) {
      let hiddenCard = this.form.activeShops.find(idx => idx === id)
      if (hiddenCard) {
        this.form.activeShops = this.form.activeShops.filter((x) => x !== id)
      } else {
        this.form.activeShops = this.form.activeShops.concat(id)
      }
    },

    isActivated(id) {
      return this.form.activeShops.findIndex(idx => idx === id) > -1;
    },
    submit() {
      const data = new FormData()
      data.append('model', this.model.id || '')
      data.append('brand', this.brand.id || '')
      data.append('reference', this.form.reference || '')
      data.append('bin', this.form.bin || '')
      data.append('cost', this.form.cost || '')
      data.append('type', this.form.type || '')
      data.append('hasItOwnStock', this.hasItOwnStock)
      data.append('category', this.form.category || '')
      let shopsQuantity = JSON.stringify(this.form.shopsQuantity)
      data.append('shopsQuantity', shopsQuantity)
      data.append('activeShops', this.form.activeShops)

      this.$inertia.post(this.route('stock.store'), data, {
        onStart: () => this.sending = true,
        onFinish: () => this.sending = false,
      })
    },
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    asyncFind() {
      const params = {
        brand: null,
      };
      this.isLoading = true
      if (this.brand != null) {
        params.brand = this.brand.id
      }

      return axios.get(this.route('stock.searchModel'), {params})
        .then(response => {
          this.model = null
          this.modelsData = response.data[0]
          this.isLoading = false
        })
    },
  },
  created() {
    const shopsQuantity = {}
    this.$page.props.shops.forEach((shop) => {
      shopsQuantity[shop.id] = null
    })
    this.form.shopsQuantity = shopsQuantity
  }
}
</script>
